// extracted by mini-css-extract-plugin
export default {"title":"title--Kp2vB","list":"list--KRm5o","item":"item--nNts_"};